// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2YpfU","inputWrap":"styles_inputWrap__aMo1v","input":"styles_input__vWKF_"};